import styled from 'styled-components';

export default styled.section`
  padding: 3.0625rem ${props => props.theme.padding.inner} 3.375rem;
  padding: ${props =>
    props.padding
      ? `2rem ${props => props.theme.padding.inner} 7.625rem`
      : '0'};

  .title {
    max-width: ${props => props.theme.maxWidths.containerSmall};
    margin: 0.83em auto;
    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.container};
    }
  }
  
  .inner {
    max-width: ${props => props.theme.maxWidths.containerSmall};
    margin: auto;
    display: flex;
    flex-direction: column;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.container};
      flex-direction: row;
      ${props => (props.justifyContent ? 'justify-content: space-around' : '')}
    }
  }

  .column {
    ${props => (props.justifyContent ? 'margin-top: 1.5rem;' : '')}

    &:first-child {
      margin-top: 0;
    }

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: 50%;
      padding: ${props => (props.padding ? '0 1.625rem' : '0')};
      box-sizing: border-box;
      margin-top: 0;
    }

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transform: translateY(10px);
        transition: all 0.4s ease-in-out;
      }
    }

    .active& {
      opacity: 1;
      transform: none;
    }
  }
`;
